"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");
/**
 * @author Tomas Leity
 */


var NChangedWinThreshold =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NChangedWinThreshold, _NotificationDoc_1$No);

  /**
   * @param promoSales
   * @param promoSalesOld
   * @param promoSalesAbsTh
   * @param promoSalesRelTh
   * @param bmProxy
   * @param bmProxyOld
   * @param bmProxyAbsTh
   * @param bmProxyRelTh
   */
  function NChangedWinThreshold(promoSales, promoSalesOld, promoSalesAbsTh, promoSalesRelTh, bmProxy, bmProxyOld, bmProxyAbsTh, bmProxyRelTh) {
    var _this;

    _classCallCheck(this, NChangedWinThreshold);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NChangedWinThreshold).call(this));
    _this.promoSales = promoSales;
    _this.promoSalesOld = promoSalesOld;
    _this.promoSalesAbsTh = promoSalesAbsTh;
    _this.promoSalesRelTh = promoSalesRelTh;
    _this.bmProxy = bmProxy;
    _this.bmProxyOld = bmProxyOld;
    _this.bmProxyAbsTh = bmProxyAbsTh;
    _this.bmProxyRelTh = bmProxyRelTh;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NChangedWinThreshold, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NChangedWinThreshold(mat.promoSales, mat.promoSalesOld, mat.promoSalesAbsTh, mat.promoSalesRelTh, mat.bmProxy, mat.bmProxyOld, mat.bmProxyAbsTh, mat.bmProxyRelTh);
    }
  }]);

  return NChangedWinThreshold;
}(NotificationDoc_1.NotificationDoc);

exports.NChangedWinThreshold = NChangedWinThreshold;

NChangedWinThreshold.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NChangedWinThreshold.name);
  return {
    promoSales: builder.opt(builder.bigNum('promoSales')),
    promoSalesOld: builder.opt(builder.bigNum('promoSalesOld')),
    promoSalesAbsTh: builder.num('promoSalesAbsTh'),
    promoSalesRelTh: builder.num('promoSalesRelTh'),
    bmProxy: builder.opt(builder.bigNum('bmProxy')),
    bmProxyOld: builder.opt(builder.bigNum('bmProxyOld')),
    bmProxyAbsTh: builder.num('bmProxyAbsTh'),
    bmProxyRelTh: builder.num('bmProxyRelTh')
  };
}();